
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import { Subscription } from "@/pages/pricing/hooks/subscription/types";

interface SubscriptionActionsProps {
  currentSubscription: Subscription | null;
  isLoading: boolean;
  onCancelSubscription: () => void;
}

export function SubscriptionActions({
  currentSubscription,
  isLoading,
  onCancelSubscription
}: SubscriptionActionsProps) {
  const isCancelled = currentSubscription?.subscription_status === 'cancelled';

  return (
    <div className="flex flex-col sm:flex-row gap-2">
      {currentSubscription?.subscription_status !== 'cancelled' && (
        <Button 
          variant="outline" 
          onClick={onCancelSubscription} 
          disabled={isLoading}
          className="w-full sm:w-auto"
        >
          <XCircle className="mr-2 h-4 w-4" /> Cancel Subscription
        </Button>
      )}
    </div>
  );
}
